import { render } from "./account_settings_section.vue?vue&type=template&id=52b11b6c&ts=true"
import script from "./account_settings_section.vue?vue&type=script&lang=ts"
export * from "./account_settings_section.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__